const Selects = () => {
  jQuery(document).ready(function ($) {
    // Список селекторов, где поиск отключен
    const selectsWithoutSearch = [
      ".select-without-search",
      ".items-per-page-select",
      ".sort-by-select",
      "#chose-wishlist-select",
      "#metals-select",
      "#colors-select",
      "#gemstone-select",
      "#size-select",
      "#mukhi-bead-customization-select",
      ".time-period",
      ".birth-city",
      ".query-type",
      ".selling-intent",
      ".referral-source",
      "#shipping_state",
      "#billing_state",
      ".variation-select",
    ];

    selectsWithoutSearch.forEach(selector => {
      $(selector).select2({
        templateResult: formatOption,
        templateSelection: formatOption,
        minimumResultsForSearch: Infinity
      });
    });

    // WooCommerce's variation form rebuilds each <option> list via raw
    // .html() + .val() (no 'change' event) whenever a variation attribute
    // changes, so select2's internal selection tracking goes stale after
    // the first change. Re-sync select2 on the variation selects whenever
    // WooCommerce finishes updating them.
    $(document).on('woocommerce_update_variation_values', '.variations_form', function () {
      $(this).find('.variation-select').each(function () {
        const $select = $(this);
        if ($select.hasClass('select2-hidden-accessible')) {
          $select.select2('destroy');
        }
        $select.select2({
          templateResult: formatOption,
          templateSelection: formatOption,
          minimumResultsForSearch: Infinity
        });
      });
    });

    // Список селекторов, где поиск включен
    const selectsWithSearch = [
      ".select-with-search",
      ".birth-country",
      "#shipping_country",
      "#billing_country",
    ];

    selectsWithSearch.forEach(selector => {
      $(selector).select2({
        templateResult: formatOption,
        templateSelection: formatOption
      });
    });

    // Список селекторов с disabled первой опцией
    const disableFirstOption = [
      ".select-disabled-first-option",
      ".sort-by-select",
      '.query-type',
      '.selling-intent',
      '.referral-source',
      '.birth-city',
      '.birth-country'
    ];

    disableFirstOption.forEach(selector => {
      $(`${selector} option:first-child`).attr('disabled', 'disabled');
    });

    // Функция для отображения опций с картинкой
    function formatOption(option) {
      let imageUrl = $(option.element).data('image');
      if (!imageUrl) return option.text;

      return $(`<span class="option-span"><img src="${imageUrl}" class="option-img" /> ${option.text}</span>`);
    }
  });
}

export default Selects;


// const Selects = () => {
//   jQuery(document).ready(function ($) {
//     $(".items-per-page-select").select2();
//     $(".sort-by-select").select2();
//     $("#chose-wishlist-select").select2();
//     $("#metals-select").select2();
//     $("#colors-select").select2();
//     $("#gemstone-select").select2();
//     $("#size-select").select2();
//     $("#mukhi-bead-customization-select").select2();
//     $(".time-period").select2();
//     $(".birth-country").select2();
//     $(".birth-city").select2();
//     $(".query-type").select2();
//     $(".selling-intent").select2();
//     $(".referral-source").select2();
//     $("#shipping_country").select2(); 
//     $("#shipping_state").select2();
//     $("#billing_country").select2();
//     $("#billing_state").select2();
    
//     $('.query-type option:first-child').attr('disabled', 'disabled');
//     $('.selling-intent option:first-child').attr('disabled', 'disabled');
//     $('.referral-source option:first-child').attr('disabled', 'disabled');
//     $('.birth-city option:first-child').attr('disabled', 'disabled');
//     $('.birth-country option:first-child').attr('disabled', 'disabled');
    
//     function formatOption(option) {
//       let imageUrl = $(option.element).data('image');
       
//       if (!imageUrl) {
//         return option.text;
//       }
     
//       let optionWithImage = $(
//         '<span class="option-span"><img src="' + imageUrl + '" class="option-img" /> ' + option.text + '</span>'
//       );

//       return optionWithImage;
//     }

//     const selectsWithoutSearch = [
//       "#items-per-page-select",
//       "#sort-by-select",
//       "#chose-wishlist-select",
//       "#metals-select",
//       "#colors-select",
//       "#gemstone-select",
//       "#size-select",
//       "#mukhi-bead-customization-select",
//       ".time-period",
//       ".birth-city",
//       ".query-type",
//       ".selling-intent",
//       ".referral-source",
//       "#shipping_state",
//       "#billing_state",
//     ];

//     selectsWithoutSearch.forEach(selector => {
//       $(selector).select2({
//         templateResult: formatOption,
//         templateSelection: formatOption,
//         minimumResultsForSearch: Infinity
//       });
//     });

//     const selectsWithSearch = [
//       ".birth-country",
//       "#shipping_country",
//       "#billing_country",
//     ];

//     selectsWithSearch.forEach(selector1 => {
//       $(selector1).select2({
//         templateResult: formatOption,
//        templateSelection: formatOption
//       });
//     });
//   });
// }

// export default Selects;


// // const Selects = () => {
// //   jQuery(document).ready(function ($) {
// //     $("#items-per-page-select:visible").select2();
// //     $("#sort-by-select:visible").select2();
// //     $("#chose-wishlist-select:visible").select2();
// //     $("#metals-select:visible").select2();
// //     $("#colors-select:visible").select2();
// //     $("#gemstone-select:visible").select2();
// //     $("#size-select:visible").select2();
// //     $("#mukhi-bead-customization-select:visible").select2();

// //     const initSelect2ForHiddenSelects = () => {
// //       const selectIds = [
// //         "#items-per-page-select",
// //         "#sort-by-select",
// //         "#chose-wishlist-select",
// //         "#metals-select",
// //         "#colors-select",
// //         "#gemstone-select",
// //         "#size-select",
// //         "#mukhi-bead-customization-select"
// //       ];

// //       selectIds.forEach((selectId) => {
// //         $(`${selectId}:not(.select2-hidden-accessible)`).each(function() {
// //           if ($(this).is(':visible')) {
// //             $(this).select2();
// //           }
// //         });
// //       });
// //     };

// //     const observer = new MutationObserver(() => {
// //       initSelect2ForHiddenSelects();
// //     });

// //     const config = {
// //       attributes: true,
// //       childList: true,
// //       subtree: true,
// //       attributeFilter: ['style', 'class']
// //     };

// //     observer.observe(document.body, config);
// //   });
// // };

// // export default Selects;

